module.exports = __webpack_public_path__ + "img/package-5.6643fab1.png";